import useTranslation from '../utils/useTranslation';
import useHomeFloatingUi from '../hooks/useHomeFloatingUi';
import { SOCIALS } from '../data/socials';

export default function FloatingContactStack() {
  const { t } = useTranslation();
  const visible = useHomeFloatingUi({ hideNearContactFooter: true });
  const phoneHref = `tel:${t('contact_phone_value').replace(/[\s-]/g, '')}`;
  const emailHref = `mailto:${t('contact_email_value')}`;

  return (
    <aside
      className={`floating-contact-stack${visible ? ' is-visible' : ''}`}
      aria-label={t('footer_contact')}
      aria-hidden={visible ? undefined : 'true'}
    >
      <a
        className="floating-contact-btn floating-contact-btn--phone"
        href={phoneHref}
        aria-label={t('contact_phone_label')}
        title={t('contact_phone_label')}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      </a>

      <a
        className="floating-contact-btn floating-contact-btn--email"
        href={emailHref}
        aria-label={t('contact_email_label')}
        title={t('contact_email_label')}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m3 7 9 6 9-6" />
        </svg>
      </a>

      {SOCIALS.map((social) => (
        <a
          key={social.id}
          className={`floating-contact-btn floating-contact-btn--${social.id}`}
          href={social.href}
          target="_blank"
          rel="noreferrer"
          aria-label={social.label}
          title={social.label}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {social.icon}
          </svg>
        </a>
      ))}
    </aside>
  );
}
